<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import apis from 'api/index';
import { mapActions, mapMutations } from 'vuex';

export default {
  created() {
    if (this.$route.query.token) {
      apis.setToken(this.$route.query.token);
    }
  },
  mounted() {
    // 物理返回键
    const $this = this;
    window.goBack = function goBack() {
      if($this.$route.name === 'home') {
        $this.backToApp();
      } else if($this.$route.name === 'charge') {
        $this.$router.push({name: 'home'});
      } else {
        $this.$router.go(-1);
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchBaseInfo'
    ]),
  },
}
</script>


<style lang="scss">
  @import "common/sass/common.scss";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
